<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <template v-slot:activator="{ on }">
      <v-btn color="primary" dark class="mb-2 d-print-none" v-on="on" small
        >Search Date</v-btn
      >
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Search By Date</span>
      </v-card-title>

      <v-card-text>
        <v-form ref="Dateform" class="mx-5">
          <BaseDate
            :loading="searching"
            :disabled="searching"
            :rules="v => !!v || 'From Date is required'"
            v-model="fromDate"
            label="From Date"
          >
          </BaseDate>
          <BaseDate
            :loading="searching"
            :disabled="searching"
            :rules="v => !!v || 'To Date is required'"
            label="To Date"
            v-model="toDate"
          >
          </BaseDate>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="blue darken-1" :disabled="searching" text @click="close"
          >Cancel</v-btn
        >
        <v-btn color="blue darken-1" :loading="searching" text @click="OnSearch"
          >Search</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    SearchFun: { type: Function, required: true },
    searching: { type: Boolean, default: false },
    Thismonth: { type: Boolean, default: false },
    // myDate: {
    //   type: Object,
    //   default: () => ({ from: this.Current().date, to: this.Current().date })
    // }
  },
  data() {
    return {
      dialog: false,
      fromDate: "",
      toDate: "",
    };
  },
  methods: {
    close() {
      this.dialog = false;
    },
    OnSearch() {
      if (this.$refs.Dateform.validate()) {
        this.SearchFun(this.fromDate, this.toDate);
      }
    },
  },
  created() {
    const { date, Thismonth } = this.Current();
    this.fromDate = this.Thismonth ? Thismonth : date;
    this.toDate = date;
  },
};
</script>
